import React from "react";
import { motion } from "framer-motion";
import { fadeIn } from "../../Variants";
import ParticlesContainer from "../Layout/ParticlesContainer";
import Avatar from "../Layout/Avatar";
import ProjectsBtn from "../Layout/ProjectsBtn";
import Head from "../Layout/Head";

const Home = () => {
  return (
    <div className="bg-primary/60 h-full">
      <Head title="Dev Forge Pro" />
      <div className="w-full h-full bg-gradient-to-r from-primary/10 via-black/30 to-black/10">
        <div className="text-center flex flex-col justify-center xl:pt-40 xl:text-left h-full container mx-auto">
          <motion.h1
            initial="hidden"
            animate="show"
            exit="hidden"
            variants={fadeIn("down", 0.2)}
            className="h1"
          >
            Transforming Ideas <br /> Into{" "}
            <span className="text-accent">Digital Reality</span>
          </motion.h1>
          <motion.p
            initial="hidden"
            animate="show"
            exit="hidden"
            variants={fadeIn("down", 0.3)}
            className="max-w-sm xl:max-w-xl mx-auto xl:mx-0 mb-10 xl:mb-16"
          >
            Hi there! I'm Butta Singh, a passionate creator dedicated to shaping
            the digital landscape. With a keen eye for design and a knack for
            cutting-edge technology, I specialize in transforming ideas into
            seamless, user-centric digital experiences. My journey is fueled by
            a commitment to innovation, problem-solving, and a love for elegant
            solutions. Let's collaborate and bring your visions to life!
          </motion.p>
          <div className="flex justify-center relative xl:hidden">
            <ProjectsBtn />
          </div>
          <motion.div
            initial="hidden"
            animate="show"
            exit="hidden"
            variants={fadeIn("down", 0.4)}
            className="hidden xl:flex"
          >
            <ProjectsBtn />
          </motion.div>
        </div>
      </div>
      <div className="w-[1200px] h-full absolute right-0 bottom-0">
        <div className="bg-none xl:bg-explosion xl:bg-cover xl:bg-right xl:bg-no-repeat w-full h-full absolute mix-blend-color-dodge translate-z-0"></div>
        <ParticlesContainer />
        <motion.div
          initial="hidden"
          animate="show"
          exit="hidden"
          variants={fadeIn("up", 0.5)}
          transition={{ duration: 1, ease: "easeInOut" }}
          className="w-full h-full max-w-[600px] max-h-[500px] absolute -bottom-32 lg:bottom-0 lg:right-[3.5%]"
        >
          <Avatar />
        </motion.div>
      </div>
    </div>
  );
};

export default Home;
